const schedulerCache = /*#__PURE__*/new Map();
export function createBatchScheduler(_ref) {
  let {
    fn,
    id,
    shouldSplitBatch,
    wait = 0,
    sort
  } = _ref;
  const exec = async () => {
    const scheduler = getScheduler();
    flush();
    const args = scheduler.map(_ref2 => {
      let {
        args
      } = _ref2;
      return args;
    });
    if (args.length === 0) return;
    fn(args).then(data => {
      if (sort && Array.isArray(data)) data.sort(sort);
      for (let i = 0; i < scheduler.length; i++) {
        var _pendingPromise$resol;
        const {
          pendingPromise
        } = scheduler[i];
        (_pendingPromise$resol = pendingPromise.resolve) === null || _pendingPromise$resol === void 0 || _pendingPromise$resol.call(pendingPromise, [data[i], data]);
      }
    }).catch(err => {
      for (let i = 0; i < scheduler.length; i++) {
        var _pendingPromise$rejec;
        const {
          pendingPromise
        } = scheduler[i];
        (_pendingPromise$rejec = pendingPromise.reject) === null || _pendingPromise$rejec === void 0 || _pendingPromise$rejec.call(pendingPromise, err);
      }
    });
  };
  const flush = () => schedulerCache.delete(id);
  const getBatchedArgs = () => getScheduler().map(_ref3 => {
    let {
      args
    } = _ref3;
    return args;
  });
  const getScheduler = () => schedulerCache.get(id) || [];
  const setScheduler = item => schedulerCache.set(id, [...getScheduler(), item]);
  return {
    flush,
    async schedule(args) {
      const pendingPromise = {};
      const promise = new Promise((resolve, reject) => {
        pendingPromise.resolve = resolve;
        pendingPromise.reject = reject;
      });
      const split = shouldSplitBatch === null || shouldSplitBatch === void 0 ? void 0 : shouldSplitBatch([...getBatchedArgs(), args]);
      if (split) exec();
      const hasActiveScheduler = getScheduler().length > 0;
      if (hasActiveScheduler) {
        setScheduler({
          args,
          pendingPromise
        });
        return promise;
      }
      setScheduler({
        args,
        pendingPromise
      });
      setTimeout(exec, wait);
      return promise;
    }
  };
}
//# sourceMappingURL=createBatchScheduler.js.map